import React from 'react'

export default function ReceiptItemHeaderStyle() {
  return (
    <style jsx='true'>
    {`
      #receipts-header-container {
        display: flex;
        padding: 10px;
      }

      #receipt-header-label {
        font-size: 1rem;
        display: flex;
        flex: 2;
        align-items: center;
      }

      #receipts-tab {
        display: flex;
        justify-content: flex-end;
      }

      .tab:hover {
        background-color: #E7E8F9;
        color: darkgrey;
      }
      .tab {
        padding: 15px;
      }
      .active-tab, .active-tab:focus {
        background-color: rgba(82, 91, 91, 0.9);
        color: #F5F8F9;
      }
    `}
    </style>
  )
}
